import { useMyStaffs as useMyStaffsQuery, usePlatformStaff as usePlatformStaffQuery } from '/app/queries/staff';
import { createSharedComposable } from '@vueuse/core';

export const useMyStaffs = createSharedComposable(() => {
	return useMyStaffsQuery();
});

export const usePlatformStaff = createSharedComposable(() => {
	return usePlatformStaffQuery();
});